export const messageHalfWay = () => (
    <>
        <p className={'desktop'}>
            <b>Congratulations! You are half way there, just a few more steps!</b> 👏
        </p>
        <p className={'mobile'}>Congrats! You are half way there. Keep filling 👏</p>
    </>
);

export const messageKeepFilling = () => (
    <>
        <p className={'desktop'}>
            <b>Reveal your best global visa pathways!</b> Keep filling the form 🌎
        </p>
        <p className={'mobile'}>Keep Filling to reveal the best Options! 🌎</p>
    </>
);

export const messageUpdateInput = () => (
    <>
        <p className={'desktop'}>
            <b>Be as precise as you can to get the most reliable results!</b>
        </p>
        <p className={'mobile'}>Be as precise as you can to get the most reliable results</p>
    </>
);
